import React from "react";

import VersionName from "../cells/VersionName";
import VersionStatusColumn from "../cells/VersionStatusColumn";
import DateCell from "../cells/DateColumn";
import TotalFileSizeColumn from "../cells/TotalFileSizeColumn";
import SelectCell from "../cells/SelectCell";
import VersionActionsCell from "../cells/VersionActions";
import WeightColumn from "../cells/WeightColumn";
import CreativeVersionsLabels from "../cells/CreativeVersionsLabels";

import { CreativeVersions } from "reducers/CreativeVersions";
import { GRID_TYPE } from "../constants";

import { TYPES } from "utils/constants";
import FilterHeader from "utils/columns/FilterHeader";
import { KILO } from "utils/common";
import { isDVAST } from "utils/CreativeActions";

import SelectAllVersionsCell from "routes/versions/SelectAllVersionsCell";

const VERSION = "windu";

function genRowId(data, str){
	return `${str}-${data}`;
}

function showFilesizeWarning(data) {
	return !isDVAST(data.adType);
}

const CREATIVE_VERSION_SELECT = {
	...SelectCell,
	headerRenderer: () => <SelectAllVersionsCell />,
	getRowMetaData(data) {
		return {
			type: TYPES.VERSIONS,
			checkboxId: genRowId(data.id, VERSION),
			isSelected: data.isSelected,
			id: data.id,
			shiftSelectConfig: {
				selectItems: (state, level) => state.creativeVersions.items,
			},
		};
	},
};

const CREATIVE_VERSION_NAME = {
	key: "name",
	name: "Version Name",
	cellClass: "fill-cell link-cell",
	width: 350,
	resizable: true,
	sortable: true,
	locked: true,
	getRowMetaData(data) {
		return {
			versionId: data.id,
			type: TYPES.VERSIONS,
			isSelected: data.isSelected,
		};
	},
	formatter: VersionName,
};

const CREATIVE_VERSION_ID = {
	key: "id",
	name: "ID",
	width: 85,
	resizable: false,
	sortable: true,
};

const CREATIVE_VERSION_STATUS = {
	key: "status",
	name: "Status",
	formatter: VersionStatusColumn,
	width: 120,
	resizable: false,
	sortable: true,
	filter: "Checkbox",
	headerRenderer: (
		<FilterHeader
			Reducer={CreativeVersions}
			filterSelector = { state => state.creativeVersions.columnFilters.active.status}
		/>
	),
	getRowMetaData(data){
		const { adType } = data;

		return {
			decisioningTypeSelector:(state => state.creativeDetails.decisioningType),
			adType,
		};
	},
};

const CREATIVE_VERSION_WEIGHT_MULTIPLIER = {
	key: "weightMultiplier",
	name: "Weight",
	formatter: WeightColumn,
	width: 104,
	resizable: false,
	sortable: true,
	filter: "Checkbox",
	headerRenderer: (
		<FilterHeader
			Reducer={CreativeVersions}
			filterSelector = { state => state.creativeVersions.columnFilters.active.weightMultiplier}
		/>
	),
};

const CREATIVE_VERSION_TOTAL_FILE_SIZE = {
	...TotalFileSizeColumn,
	name: "Version File Size",
	filter: "Range",
	headerRenderer: (
		<FilterHeader
			Reducer={CreativeVersions}
			filterSelector = { state => state.creativeVersions.columnFilters.active.filesize}
		/>
	),
	getRowMetaData(data){
		return {
			type: GRID_TYPE.VERSION,
			sizeLimitSelector: (state => (state.libraryProperties?.contentLimitInKilobytes * KILO || 0)),
			shouldShowWarning: showFilesizeWarning(data),
		};
	},
};

const CREATIVE_VERSION_AUTO_CLASSIFICATION_STATUS = {
	key: "autoClassificationStatus",
	name: "Auto-classification Status",
	width: 185,
	sortable: true,
	filter: "Checkbox",
	headerRenderer: (
		<FilterHeader
			Reducer={CreativeVersions}
			filterSelector = { state => state.creativeVersions.columnFilters.active.autoClassificationStatus }
		/>
	),
};

const CREATIVE_VERSIONS_LABELS = {
	name: "Creative Labels",
	key: "labelsCnt",
	filter: "Range",
	width: 130,
	resizable: true,
	sortable: true,
	formatter: CreativeVersionsLabels,
	headerRenderer: (
		<FilterHeader
			Reducer = {CreativeVersions}
			filterSelector = {state => state.creativeVersions.columnFilters.active.labelsCnt}
		/>
	),
	getRowMetaData(data){
		return {
			creativeId: data.creativeId,
			libraryId: data.libraryId,
			versionId: data.id,
		};
	},
};

const CREATIVE_VERSION_DATE = {
	...DateCell,
	key: "lastUpdateDate",
	name: "Last Modified",
	filter: "Date",
	headerRenderer: (
		<FilterHeader
			Reducer={CreativeVersions}
			filterSelector = { state => state.creativeVersions.columnFilters.active.lastUpdateDate}
		/>
	),
};

export const CREATIVE_VERSION_COLUMNS = [
	CREATIVE_VERSION_SELECT,
	CREATIVE_VERSION_NAME,
	CREATIVE_VERSION_ID,
	VersionActionsCell,
	CREATIVE_VERSION_STATUS,
	CREATIVE_VERSION_WEIGHT_MULTIPLIER,
	CREATIVE_VERSION_TOTAL_FILE_SIZE,
	CREATIVE_VERSIONS_LABELS,
	CREATIVE_VERSION_AUTO_CLASSIFICATION_STATUS,
	CREATIVE_VERSION_DATE,
];

export const CREATIVE_SOCIAL_VERSION_COLUMNS = [
	CREATIVE_VERSION_SELECT,
	CREATIVE_VERSION_NAME,
	CREATIVE_VERSION_ID,
	VersionActionsCell,
	{ ...CREATIVE_VERSION_STATUS, name: "Published" },
	CREATIVE_VERSIONS_LABELS,
	CREATIVE_VERSION_AUTO_CLASSIFICATION_STATUS,
	CREATIVE_VERSION_DATE,
];
